import { useMemo } from "react";

import { useUploadsApiService } from "shared/services";

import useToast from "./useToast";

import type { UploadValidateTypes } from "../types";

const useUploads = () => {
	const uploadsService = useUploadsApiService();

	const { showToast } = useToast();

	return useMemo(() => {
		return {
			getGoogleSheet: async (template?: UploadValidateTypes) => {
				try {
					const { sheet } = await uploadsService.getGoogleSheet(template);
					return sheet;
				} catch (error) {
					showToast({ text: "Error inviting followers", noIcon: true });
					console.error("Invite followers to club failed", error);
				}
			}
		};
	}, [uploadsService, showToast]);
};

export default useUploads;
